import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ContextualMenu, IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import ContextMenuInfo from '../../store/schema/ContextMenuInfo';
import { IPoint } from '@fluentui/react/lib/Utilities';

export interface TimeStripHeaderContextMenuProps {
    timeZone: string;
    anchorPoint: IPoint;
    contextMenus: ContextMenuInfo[];
    onDismiss: (ev?: React.MouseEvent | React.KeyboardEvent, dismissAll?: boolean) => void;
}

const TimeStripHeaderContextMenu: React.FunctionComponent<TimeStripHeaderContextMenuProps> = observer(
    function TimeStripHeaderContextMenu(props: TimeStripHeaderContextMenuProps) {
        const { timeZone, contextMenus, onDismiss, anchorPoint } = props;
        const items = populateMenuItems(timeZone, contextMenus);

        return <ContextualMenu items={items} target={anchorPoint} onDismiss={onDismiss} />;
    }
);

export default TimeStripHeaderContextMenu;

function populateMenuItems(
    timeZone: string,
    contextMenus: ContextMenuInfo[]
): IContextualMenuItem[] {
    let menuItems: IContextualMenuItem[] = [];

    contextMenus.forEach(contextMenu => {
        menuItems.push({
            key: contextMenu.label,
            name: contextMenu.label,
            onClick: () => contextMenu.onClick(timeZone),
        });
    });

    return menuItems;
}
